<template>
  <div style="height: 100%">
    <div style="height: 50px;margin-left: 15px">
      <div style="float: left">
        <span>围栏类型：</span>
        <el-select v-fixZoom size="small" v-model="circle_type" style="width: 200px" placeholder="请选择围栏类型" @change="getChangeType">
          <el-option v-for="item in typeArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>&nbsp;&nbsp;
      </div>
      <div v-if="circle_type === 1" style="float: left">
        <el-button size="small" type="primary" :disabled="circle === null" @click="resetCircle()">重新选择</el-button>
        <el-button v-if="circlePoint.point.length !== 0 && circlePoint.radius !== ''" size="small" type="primary" @click="getCircleMap()" :disabled="circle !== null">构建圆形</el-button>
        <el-button v-else size="small" type="primary" :disabled="true">构建圆形</el-button>
        <el-button size="small" type="primary" :disabled="circle === null" @click="startEditCircle()">开始编辑</el-button>
        <el-button size="small" type="primary" :disabled="circle === null" @click="endEditCircle()">结束编辑</el-button>
        <el-button size="small" type="success" :disabled="circle === null" @click="saveCirclePolygon()">保存</el-button>
      </div>
      <div v-else-if="circle_type === 2" style="float: left">
        <el-button size="small" type="primary" :disabled="polygon === null" @click="resetPolygon()">重新选择</el-button>
        <el-button v-if="polygonPoint.length !== 0" size="small" type="primary" @click="getPolygonMap()" :disabled="polygon !== null">构建多边形</el-button>
        <el-button v-else size="small" type="primary" :disabled="true">构建多边形</el-button>
        <el-button size="small" type="primary" :disabled="polygon === null" @click="startEditPolygon()">开始编辑</el-button>
        <el-button size="small" type="primary" :disabled="polygon === null" @click="endEditPolygon()">结束编辑</el-button>
        <el-button size="small" type="success" :disabled="polygon === null" @click="saveCirclePolygon()">保存</el-button>
      </div>
<!--      <div v-else style="font-size: 14px;color: #f67373;line-height: 50px">请先选择围栏类型进行绘制。</div>-->
    </div>
    <div class="search-inpt">
      <div style="margin-top: 15px;margin-left: 30px">
        <el-autocomplete v-fixZoom v-if="circle_type === 1" size="small" style="width: 300px" class="inline-input" v-model="keyword" :disabled="circle !== null"
                         :fetch-suggestions="searchChange" placeholder="输入关键字选取地点" :trigger-on-focus="false" @select="searchSelect"
        ></el-autocomplete>
        <el-autocomplete v-fixZoom v-if="circle_type === 2" size="small" style="width: 300px" class="inline-input" v-model="keyword" :disabled="polygon !== null"
                         :fetch-suggestions="searchChange" placeholder="输入关键字选取地点" :trigger-on-focus="false" @select="searchSelect"
        ></el-autocomplete>
        <el-input v-if="circle_type === 1" size="small" style="width: 110px" type="number" placeholder="输入半径(单位:米)" v-model="circlePoint.radius" :disabled="circle !== null"></el-input>
      </div>
    </div>
    <div style="height: calc(100% - 70px);">
      <div :style="{height: '100%', zoom: 1 / this.golobleObject.zoom}" id="map"></div>
    </div>
  </div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader'
export default {
  name: 'electronicFence',
  props: {
    trackObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      typeArr: [{name: '圆形', id: 1}, {name: '多边形', id: 2}],
      isAdd: false,
      layer: null,
      keyword: '',
      circle_type: '',
      circleType: '',
      // 圆形
      circlePoint: {
        point: [],
        radius: ''
      },
      circle: null,
      circleEditor: null,
      // 多边形
      polygonPoint: [], // [[116.475334, 39.997534], [116.476627, 39.998315], [116.478603, 39.99879], [116.478529, 40.000296], [116.475082, 40.000151], [116.473421, 39.998717]],
      polygon: null,
      polyEditor: null,
      // 点
      markers: [],
      // 搜索
      auto: null,
      placeSearch: null,
      lnglat: [],
      search: null,
      lastPath: null
    }
  },
  created () {
  },
  mounted () {
    this.getMap()
  },
  destroyed () {
    window.map = null
  },
  methods: {
    searchSelect (e) {
      // console.log(33, e.poi)
      window.map.setCenter(e.poi)
      this.setMarker([e.poi.lng, e.poi.lat])
    },
    searchChange (v, v1) {
      // console.log(v)
      this.search.search(v, (status, result) => {
        // console.log(status, result)
        v1(result.poiList.pois.map(val => {
          // console.log(val)
          return {value: val.name, id: val.id, poi: val.location}
        }))
      })
    },
    // 编辑画图
    getEditDataMap (obj) {
      // console.log(123)
      this.circle_type = obj.circle_type
      this.circleType = obj.circle_type
      if (obj.circle_type === 1) {
        let area = JSON.parse(obj.circle_area)
        this.circlePoint = {
          point: [area.point.y, area.point.x],
          radius: parseInt(area.radius)
        }
        this.getCircleMap()
      } else if (obj.circle_type === 2) {
        this.polygonPoint = []
        let area = JSON.parse(obj.circle_area)
        let path = []
        if (area['point1']) {
          path.push([area['point1'].y, area['point1'].x])
        }
        if (area['point2']) {
          path.push([area['point2'].y, area['point2'].x])
        }
        if (area['point3']) {
          path.push([area['point3'].y, area['point3'].x])
        }
        if (area['point4']) {
          path.push([area['point4'].y, area['point4'].x])
        }
        if (area['point5']) {
          path.push([area['point5'].y, area['point5'].x])
        }
        if (area['point6']) {
          path.push([area['point6'].y, area['point6'].x])
        }
        if (area['point7']) {
          path.push([area['point7'].y, area['point7'].x])
        }
        if (area['point8']) {
          path.push([area['point8'].y, area['point8'].x])
        }
        this.polygonPoint = path
        this.getPolygonMap()
      }
    },
    getChangeType (type) {
      this.removeMarker()
      if (this.circleType === 1) {
        this.resetCircle()
      } else if (this.circleType === 2) {
        this.resetPolygon()
      }
      this.circleType = parseInt(type)
    },
    getMap () {
      console.log(1234)
      const vm = this
      AMapLoader.load({
        key: 'cc3b1554350ef292385401f1f51bd547',
        version: '2.0',
        plugins: [
          'AMap.PolygonEditor',
          'AMap.Autocomplete',
          'AMap.PlaceSearch',
          'AMap.Driving',
          'AMap.DragRoute',
          'AMap.Scale',
          'AMap.OverView',
          'AMap.ToolBar',
          'AMap.MapType',
          'AMap.PolyEditor',
          'AMap.CircleEditor',
          'AMap.Geolocation',
          'AMap.Geocoder',
          'AMap.AMapUI'
        ] // 需要使用的的插件列表
      }).then(AMap => {
        window.map = new AMap.Map('map', {
          viewMode: '2D', // 是否为3D地图模式
          zoom: 13, // 初始化地图级别
          // center: [116.475334, 39.997534], // 中心点坐标
          resizeEnable: true
        })
        vm.search = new AMap.PlaceSearch({
          map: window.map
        })
        // 监听鼠标点击事件
        window.map.on('click', vm.clickMapHandler)
        // 函数调用（写入你先所需要的事件函数）
        // vm.searchMap() // POI关键字搜索
        // ...其他
        vm.layer = new AMap.TileLayer.Satellite()
      })
    },
    // 鼠标点击事件
    clickMapHandler (e) {
      let lnglat = [e.lnglat.getLng(), e.lnglat.getLat()]
      this.setMarker(lnglat)
    },
    // 添加点
    setMarker (lnglat) {
      if (this.circle_type === 1) {
        if (this.circle === null) {
          this.removeMarker()
          // console.log('位置', lnglat)
          // eslint-disable-next-line no-undef
          let marker = new AMap.Marker({
            position: lnglat
          })
          marker.setMap(window.map)
          this.markers.push(marker) // 在data中记录标记点
          this.circlePoint.point = lnglat
          // console.log(this.circlePoint.point)
        }
      } else if (this.circle_type === 2) {
        // console.log(this.markers.length)
        if (this.polygon === null) {
          if (this.markers.length > 8) {
            this.$message.error('最多构建8个点。')
          } else {
            // eslint-disable-next-line no-undef
            let marker = new AMap.Marker({
              position: lnglat
            })
            marker.setMap(window.map)
            this.markers.push(marker) // 在data中记录标记点
            this.polygonPoint.push(lnglat)
          }
        }
      }
    },
    // 删除之前后的标记点
    removeMarker () {
      // 判断是否存被标记的点，有--->移除
      if (this.markers.length > 0) {
        window.map.remove(this.markers)
      }
      this.markers = []
    },
    // 圆形
    getCircleMap () {
      // eslint-disable-next-line no-undef
      this.circle = new AMap.Circle({
        center: this.circlePoint.point,
        radius: parseInt(this.circlePoint.radius), // 半径
        borderWeight: 3,
        strokeColor: 'rgba(218, 75, 75, 0.2)',
        // strokeOpacity: 1,
        strokeWeight: 6,
        strokeOpacity: 0.2,
        fillOpacity: 0.4,
        strokeStyle: 'dashed',
        strokeDasharray: [10, 10],
        // 线样式还支持 'dashed'
        fillColor: '#d36b6b',
        zIndex: 50
      })
      window.map.add(this.circle)
      window.map.setFitView([this.circle])
      // eslint-disable-next-line no-undef
      this.circleEditor = new AMap.CircleEditor(window.map, this.circle)
      let obj = {
        type: 1,
        circleObj: this.circlePoint
      }
      this.$emit('getMapArea', obj)
    },
    resetCircle () {
      if (this.circle) {
        window.map.remove(this.circle)
        this.removeMarker()
        this.circle = null
      }
      this.circlePoint = {
        point: [],
        radius: ''
      }
    },
    startEditCircle () {
      this.circleEditor.open()
    },
    endEditCircle () {
      this.circleEditor.close()
      this.circlePoint.radius = this.circle.getRadius()
      console.log(888, this.circlePoint)
    },
    // 多边形
    getPolygonMap () {
      let path = this.polygonPoint
      // eslint-disable-next-line no-undef
      this.polygon = new AMap.Polygon({
        path: path,
        strokeColor: '#FF33FF',
        strokeWeight: 6,
        strokeOpacity: 0.2,
        fillOpacity: 0.4,
        fillColor: '#1791fc',
        zIndex: 50
      })
      window.map.add(this.polygon)
      window.map.setFitView([this.polygon])
      this.removeMarker()
      // eslint-disable-next-line no-undef
      this.polyEditor = new AMap.PolyEditor(window.map, this.polygon)
      let obj = {
        type: 2,
        polygonArr: this.polygonPoint
      }
      this.$emit('getMapArea', obj)
    },
    resetPolygon () {
      if (this.polygon) {
        window.map.remove(this.polygon)
        this.removeMarker()
        this.polygon = null
      }
      this.polygonPoint = []
    },
    startEditPolygon () {
      const vm = this
      // console.log(456, this.polyEditor)
      this.polyEditor.open()
      // console.log(789, this.polygon.getPath().length)
      this.lastPath = this.polygon.getPath()
      this.polyEditor.on('addnode', (e) => {
        if (vm.polygon.getPath().length > 8) {
          vm.polygon.setPath(vm.lastPath)
          vm.$message.error('最多构建8个点。')
        } else {
          vm.lastPath = vm.polygon.getPath()
        }
      })
    },
    endEditPolygon () {
      this.polyEditor.close()
      let arr = this.polygon.getPath()
      this.polygonPoint = []
      for (let i = 0; i < arr.length; i++) {
        this.polygonPoint.push([arr[i].lng, arr[i].lat])
      }
      console.log(999, this.polygonPoint)
    },
    // 最后提交
    saveCirclePolygon () {
      if (this.circle_type === 1) {
        console.log(888, this.circlePoint)
      } else {
        console.log(999, this.polygonPoint)
      }
    }
  }
}
</script>

<style scoped>
.icon-map{
  position: relative;
  top: 20px;
  left: 20px;
  width: 40px;
  height: 80px;
  background-color: #FFFFFF;
  box-shadow: 0 0 10px 0 #999999;
  border-radius: 4px;
  z-index: 999;
  cursor: pointer;
  text-align: center;
}
.search-inpt{
  z-index: 999;
  /*background-color: #7c98d9;*/
  height: 60px;
  width: 450px;
  position: absolute;
}
.inpt-box{
  margin-left: 30px;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/electronicFence.vue